import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { ILogsTableRow } from '../../merchnts/merchant-interfaces';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../../../components/merchants/RelatedEntityNameLink';
import { WhisperComponent } from '../../../components/developers/page-components/WhisperComponent';
import { getReasonPhrase } from 'http-status-codes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamation, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';
import { DateComponent } from '../../../components/DateComponent';

export enum WebhookActivityTableAccessorKeys {
	mid = 'mid',
	status = 'status',
	eventName = 'eventName',
	eventInvocationId = 'eventInvocationId',
	date = 'timeStamp',
	environment = 'environment',
}

export const defaultWebhookActivityColumnSizing: ColumnSizing = {
	[WebhookActivityTableAccessorKeys.mid]: 100,
	[WebhookActivityTableAccessorKeys.status]: 70,
	[WebhookActivityTableAccessorKeys.eventName]: 120,
	[WebhookActivityTableAccessorKeys.eventInvocationId]: 120,
	[WebhookActivityTableAccessorKeys.date]: 70,
	[WebhookActivityTableAccessorKeys.environment]: 70,
};

export const defaultWebhookActivityColumns: MRT_ColumnDef<ILogsTableRow>[] = [
// @ts-ignore
	{
		accessorKey: WebhookActivityTableAccessorKeys.mid,
		header: 'Merchant name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Merchant name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7 ms-3"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<RelatedEntityNameLink id={renderedCellValue} type={RELATED_ENTITY_TYPE.MERCHANT} />
			</ TableCell>
		)
	},
	{
		accessorKey: WebhookActivityTableAccessorKeys.status,
		header: 'HTTP status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">HTTP status</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			return (
				<TableCell
					additionalClass="d-flex align-items-center main-font-family text-black fs-7 w-100px"
					density={table?.options?.state?.density}
					isTextOverflow={false}
				>
					<div className="me-1 fs-7">{renderedCellValue}</div>
					<WhisperComponent
						isTooltip
						whisperText={getReasonPhrase(renderedCellValue)}
						mainText={
							<FontAwesomeIcon
								icon={faQuestionCircle}
								className="cursor-pointer"
								width={12}
							/>
						}
					/>
					<div className="ms-2 status-box position-relative">
						<FontAwesomeIcon
							icon={renderedCellValue === '200' ? faCheck : faExclamation}
							className={clsx('position-absolute status-icon', renderedCellValue !== '200' && 'text-danger')}
						/>
					</div>
				</ TableCell>
			);
		}
	},
	{
		accessorKey: WebhookActivityTableAccessorKeys.eventName,
		header: 'Event name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Event name</span>,
		Cell: ({ renderedCellValue, row, table }: any): JSX.Element => {
			return (
				<TableCell
					additionalClass="d-flex align-items-center main-font-family text-black fs-7"
					density={table?.options?.state?.density}
					isTextOverflow={true}
				>
					<span className="fs-7 me-2 fc-text-overflow">
            {renderedCellValue}
          </span>
					{
						row?.original?.summary !== 'None' && (
							<WhisperComponent
								isTooltip
								whisperText={row?.original?.summary}
								mainText={
									<FontAwesomeIcon
										icon={faQuestionCircle}
										className="cursor-pointer"
										width={12}
									/>
								}
							/>
						)
					}
				</ TableCell>
			);
		}
	},
	{
		accessorKey: WebhookActivityTableAccessorKeys.eventInvocationId,
		header: 'Event id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Event id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fc-text-overflow fw-bolder">
					{renderedCellValue}
				</div>
			</ TableCell>
		)
	},
	{
		accessorKey: WebhookActivityTableAccessorKeys.date,
		header: 'Date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<DateComponent
					value={renderedCellValue}
					isTime
				/>
			</ TableCell>
		)
	},
	{
		accessorKey: WebhookActivityTableAccessorKeys.environment,
		header: 'Environment',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Environment</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fc-text-overflow">
					{renderedCellValue}
				</div>
			</ TableCell>
		)
	},

];
